import { render, staticRenderFns } from "./floorvalue.vue?vue&type=template&id=200fe844&"
import script from "./floorvalue.vue?vue&type=script&lang=js&"
export * from "./floorvalue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200fe844')) {
      api.createRecord('200fe844', component.options)
    } else {
      api.reload('200fe844', component.options)
    }
    module.hot.accept("./floorvalue.vue?vue&type=template&id=200fe844&", function () {
      api.rerender('200fe844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l4tHitJsCT70/JS/comp/floorvalue.vue"
export default component.exports